import axios from 'axios';
import { generateUrl } from '../helper';
import { CAPACITY_RETRY_DELAYS_MS, isCapacityError, withNeutralCapacityMessage } from './capacityRetry';
const interview = axios.create({
    baseURL: generateUrl('interview_backend'),
});

interview.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem('token');
        const tenantId = localStorage.getItem('tenantId');

        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (tenantId && tenantId !== 'undefined' && tenantId !== 'null') {
            config.headers['x-tenant-id'] = tenantId;
        } else {
            delete config.headers['x-tenant-id']; // ✅ Remove stale tenant header if not present
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

interview.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        // return Promise.reject(error);
        const config = error?.config;
        const attempt = config?.capacityRetryAttempt ?? 0;
        if (!isCapacityError(error) || !config) return Promise.reject(error);
        // if (attempt >= CAPACITY_RETRY_DELAYS_MS.length) return Promise.reject(withNeutralCapacityMessage(error));
        if (attempt >= Math.min(config.capacityRetryMax ?? Infinity, CAPACITY_RETRY_DELAYS_MS.length))
            return Promise.reject(withNeutralCapacityMessage(error));
        return new Promise((resolve) => setTimeout(resolve, CAPACITY_RETRY_DELAYS_MS[attempt])).then(() =>
            interview({ ...config, capacityRetryAttempt: attempt + 1 })
        );
    }
);

export default interview;
